/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetOrderReportDetailsQuery } from '../../models/get-order-report-details-query';
import { GetOrderReportDetailsQueryResult } from '../../models/get-order-report-details-query-result';

export interface ApiNurseryManagerReportsGetOrdersStakeholderDetailsReportPost$Plain$Params {
      body?: GetOrderReportDetailsQuery
}

export function apiNurseryManagerReportsGetOrdersStakeholderDetailsReportPost$Plain(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerReportsGetOrdersStakeholderDetailsReportPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetOrderReportDetailsQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerReportsGetOrdersStakeholderDetailsReportPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetOrderReportDetailsQueryResult>;
    })
  );
}

apiNurseryManagerReportsGetOrdersStakeholderDetailsReportPost$Plain.PATH = '/api/NurseryManager/Reports/GetOrdersStakeholderDetailsReport';
